import { render, staticRenderFns } from "./AdminAttachmentList.vue?vue&type=template&id=13de4c50&scoped=true"
import script from "./AdminAttachmentList.vue?vue&type=script&lang=js"
export * from "./AdminAttachmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13de4c50",
  null
  
)

export default component.exports